<script>
    import { _ } from 'svelte-i18n';
    import axios from 'axios';
    import { url } from '../stores/url.js';
    import { roles } from '../stores/roles.js'; 
    import { user } from '../stores/user.js';
    import { users } from '../stores/users.js'; 
    import { permissions } from '../stores/permissions.js'; 
    import { swalConfirm } from '../functions/html-helpers.js';
    import { request  } from '../functions/http-helpers.js'
    import { location, link, push } from 'svelte-spa-router'

    let bv_firstname = $user.firstname;
    let bv_lastname = $user.lastname;


    /* Events */
    async function logout() {
        $user = {};
        push('/auth/login');
    }


    /* UPDATE */
    async function saveUserField(field, e) {
        const [ data, error ] = await request('put', `${$url}/user/update/${$user.id}`, {
            field: field,
            value: e.target.value
        });
        if(!error) {
            if(field == 'firstname') {
                $user.firstname = bv_firstname;
            } else if(field == 'lastname') {
                $user.lastname = bv_lastname;
            }
        }
    }

</script>



<div class="uk-container uk-margin-top  uk-margin-bottom">
    <div class="card">
        <h3>{$_('profile')}</h3>

        <div uk-grid>
            <div class="uk-width-1-1">
                {$_('user-nr')}: {$user.nr}
            </div>

            <div class="uk-width-1-2">
                <label>Vorname: </label>
                <input type="text" class="uk-input" bind:value={bv_firstname} on:keyup={e => e.key == 'Enter' && saveUserField('firstname', e)} />
            </div>
            <div class="uk-width-1-2"> 
                <label>Nachname: </label>
                <input type="text" class="uk-input" bind:value={bv_lastname} on:keyup={e => e.key == 'Enter' && saveUserField('lastname', e)} />
            </div>

            <div class="uk-width-1-1">
                <button class="btn btn-default" uk-toggle="target: #m_imprint">
                    {$_('imprint')}
                </button>
            </div> 
            <div class="uk-width-1-1"> 
                <button class="btn btn-default" uk-toggle="target: #m_dse">
                    {$_('dse')} 
                </button>
            </div>

            <div class="uk-width-1-1"> 
                <button class="btn-default" on:click={() => logout()}>{$_('logout')}</button>
            </div>
        </div>
    </div>

    <div id="m_imprint" class="uk-flex-top" uk-modal>
        <div class="uk-modal-dialog uk-modal-body uk-margin-auto-vertical">
    
            <button class="uk-modal-close-default" type="button" uk-close></button>
    
            <p>
                Impressum für das Zeiterfassungstool von ikb-technology:
            </p>

            <p>
                Angaben gemäß § 5 TMG:
            </p>

            <p>
                IKB-Technology UG (haftungsbeschränkt) Uracherstr. 13 72525 Münsingen
            </p>

            <p>
                E-Mail: info@ikb-technology.de
            </p>

            <p>
                Umsatzsteuer-ID: DE355073169
            </p>

            <p>
                Verantwortlich für den Inhalt nach § 18 Abs. 2 MStV: IKB-Technology UG (haftungsbeschränkt)
            </p>

            <p>
                Haftungshinweis: Trotz sorgfältiger inhaltlicher Kontrolle übernehmen wir keine Haftung für die Inhalte externer Links. Für den Inhalt verlinkter Seiten sind ausschließlich deren Betreiber verantwortlich. Die Europäische Kommission muss eine Europäische Plattform („OS-Plattform“) zur Online-Streitbeilegung bereitstellen. Die Betriebssystemplattform ist unter der Internetadresse http://ec.europa.eu/consumers/odr/ erreichbar.
            </p>    
        </div>
    </div>

    <div id="m_dse" class="uk-flex-top" uk-modal>
        <div class="uk-modal-dialog uk-modal-body uk-margin-auto-vertical">
    
            <button class="uk-modal-close-default" type="button" uk-close></button>
    
            <h3>Datenschutzerklärung für das Zeiterfassungstool von ikb-technology UG</h3>
            
            <p>
                Wir bei ikb-technology UG nehmen den Schutz Ihrer personenbezogenen Daten sehr ernst. Mit dieser Datenschutzerklärung möchten wir Ihnen transparent darlegen, wie wir Ihre Daten erfassen, verwenden, speichern und schützen, wenn Sie unser Zeiterfassungstool nutzen. Bitte lesen Sie diese Erklärung sorgfältig durch, um ein Verständnis dafür zu entwickeln, wie wir mit Ihren Daten umgehen.
            </p>

            <p>
                1.	Erfasste Daten: Wir erfassen alle personenbezogenen Daten, die Sie beim Verwenden unseres Zeiterfassungstools angeben. Dazu gehören Name, E-Mail-Adresse, Position, Abteilung sowie Informationen zu Arbeitszeiten und Projektzuordnungen. Diese Daten werden zur effektiven Verwaltung der Arbeitszeit und zur Erstellung von Berichten genutzt.   
            </p>

            <p>
                2.	Verwendung der personenbezogenen Daten: Die von uns erfassten personenbezogenen Daten werden ausschließlich für interne Zwecke verwendet. Sie dienen der zeiterfassungsbezogenen Verwaltung von Mitarbeitern, der Gehaltsabrechnung und der Optimierung von Arbeitsprozessen. Wir verwenden Ihre Daten nicht für Marketingzwecke oder geben sie an Dritte weiter.
            </p>

            <p>
                3.	Speicherung und Sicherheit der Daten: Wir speichern Ihre Daten in einer verschlüsselten Cloud-Infrastruktur in Deutschland. Modernste Sicherheitstechnologien und -verfahren werden angewendet, um den Schutz Ihrer Daten zu gewährleisten. Wir treffen geeignete technische und organisatorische Maßnahmen, um unbefugten Zugriff, Missbrauch oder Verlust Ihrer Daten zu verhindern.
            </p>

            <p>
                4.	Aufbewahrungsdauer der Daten: Wir bewahren Ihre personenbezogenen Daten so lange auf, wie es für den Zweck der Zeiterfassung und -abrechnung erforderlich ist. Wenn ein Mitarbeiter das Unternehmen verlässt, werden die Daten nach Ablauf der gesetzlich vorgeschriebenen Aufbewahrungsfristen sicher gelöscht.
            </p>

            <p>
                5.	Zugriff auf die Daten: Der Zugriff auf Ihre personenbezogenen Daten wird auf das erforderliche Mindestmaß beschränkt. Nur interne Mitarbeiter von ikb-technology UG, die für die Verwaltung der Zeiterfassung verantwortlich sind, haben Zugriff auf Ihre Daten. Externe Parteien erhalten keine Zugriffsberechtigungen. Unsere Mitarbeiter sind verpflichtet, Vertraulichkeitsvereinbarungen zu unterzeichnen und den strengen Datenschutzrichtlinien zu folgen.
            </p>


            <p>
                6.	Benutzerrechte: Gemäß den geltenden Datenschutzgesetzen haben Sie das Recht, auf Ihre personenbezogenen Daten zuzugreifen, sie zu korrigieren, zu ergänzen oder zu löschen. Wenn Sie solche Anfragen stellen möchten, kontaktieren Sie bitte unseren Datenschutzbeauftragten. Wir werden Ihre Anfragen innerhalb einer angemessenen Frist bearbeiten.
            </p>

            <p>
                7.	Datenübermittlung in Drittländer: Wir übermitteln Ihre personenbezogenen Daten nicht in Drittländer außerhalb der Europäischen Union. Ihre Daten werden ausschließlich innerhalb Deutschlands gespeichert und verarbeitet.
            </p>

            <p>
                Wir sind bestrebt, die Sicherheit und Integrität Ihrer Daten zu gewährleisten. Dennoch möchten wir darauf hinweisen, dass keine Datenübertragung im Internet hundertprozentig sicher ist. Wir können daher keine absolute Sicherheit garantieren, obwohl wir angemessene Maßnahmen zum Schutz Ihrer Daten ergreifen.
            </p>
    
        </div>
    </div>
</div>